import * as React from "react";
import { cn } from "@/shared/lib/utils";

import ArrowIconBlack from "@/assets/icons/arrow/linkBlack.svg?react";

interface IArrowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string
}

const ArrowButton = React.forwardRef<HTMLButtonElement, IArrowButtonProps>(
    ({ className, ...props }, ref) => {

        const [pressed, setPressed] = React.useState<boolean>(false);
        const [hovered, setHovered] = React.useState<boolean>(false);

        return (
            <button
                ref={ref}
                className={cn(
                    "bg-white rounded-full w-[34px] h-[34px] md:w-[40px] md:h-[40px] flex justify-center items-center",
                    className
                )}
                {...props}
                onMouseDown={()=>setPressed(true)}
                onMouseUp={()=>setPressed(false)}
                onMouseEnter={()=>setHovered(true)}
                onMouseLeave={()=>{setPressed(false); setHovered(false)}}
                
                onTouchStart={()=>setPressed(true)}
                onTouchEnd={()=>setPressed(false)}
            >
                <ArrowIconBlack className={cn(
                    "w-[14px] h-[14px] transition-all duration-200",
                    hovered && "w-[18px] h-[18px]",
                    pressed && "w-[14px] h-[14px]"
                )}/>
            </button>
        );
    }
);

ArrowButton.displayName = "ArrowButton";

export default ArrowButton;